import { ToolsClass } from '../../classes/tools.class'
import { COOKIES } from '../../const/cookies.const'

const state = {
  darkThemeMode: false,
  codeSwitchers: {
    'Swift-Objective-C-Switch': 'Swift'
  }
}

const mutations = {
  setDarkThemeMode (state, value) {
    state.darkThemeMode = value
    const expireDays = 365
    if (state.darkThemeMode) {
      if (!ToolsClass.getCookie(COOKIES.darkMode)) {
        ToolsClass.setCookie(COOKIES.darkMode, '', expireDays)
      }
    } else {
      ToolsClass.removeCookie(COOKIES.darkMode)
    }
  },
  setCodeSwitchers (state, value) {
    state.codeSwitchers = value
  }
}

const actions = {}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
